import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AccordionWrapper } from './AccordianStyled';

export const AccordionComp = ({ title, subtitle, children, expanded, disabled }) => {
    return (
        <AccordionWrapper sx={{boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px"}}>
            <Accordion disabled={disabled}  defaultExpanded={expanded}  elevation={0}>
                <AccordionSummary 
                    className='accordian'
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>{title}</Typography>
                    <span aria-required>{subtitle}</span>
                </AccordionSummary>
                <AccordionDetails >
                    {children}
                </AccordionDetails>
            </Accordion>
        </AccordionWrapper>
    );
}

export default AccordionComp;